// Recommendation from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder#description
export const modulo = (n: number, d: number): number => ((n % d) + d) % d;
